import React from 'react';
import Heading from '../../../../Heading';
import { ModalHeadingProps } from './ModalHeading.types';

const ModalHeading = ({
  className,
  size = 'large',
  ...restProps
}: ModalHeadingProps) => (
  <Heading {...restProps} size={size} className={className} />
);

ModalHeading.propTypes = Heading.propTypes;

export default ModalHeading;
